<template>
	<page>
		<module>
			<view-list
				ref="view"
				work-type="303"
				:view-config="saasInfo.viewmanage"
				selector
			>
				<template #search>
					<!--调拨方向（我调出的/调拨给我的）不做硬编码页签，由视图配置的过滤字段（direction）生成视图页签-->
					<m-search ref="search">
						<m-search-item label="调拨单号">
							<c-input name="transfer_code" placeholder="请输入调拨单号"></c-input>
						</m-search-item>
						<m-search-item label="背贴码">
							<c-input name="produce_unique_code" placeholder="请输入背贴码"></c-input>
						</m-search-item>
						<m-search-item label="对方商户">
							<c-input name="merchant_name" placeholder="请输入对方商户名称"></c-input>
						</m-search-item>
						<m-search-item label="接收状态">
							<c-select name="receive_state" :options="PROFIT_RECEIVE_STATE" placeholder="全部"></c-select>
						</m-search-item>
						<m-search-item label="销售状态">
							<c-select name="sale_state" :options="PROFIT_SALE_STATE" placeholder="全部"></c-select>
						</m-search-item>
						<m-search-item label="是否结算">
							<c-select name="settle_state" :options="PROFIT_SETTLE_STATE" placeholder="全部"></c-select>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_profit_transfer_settle')" color="main" prepend-icon="tf-check" @click="batchSettle">批量结算</c-button>
					<c-button v-if="auth('b_profit_transfer_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
				</template>

				<template #product_info="{data}">
					<m-product-info :name="data.product_info" :level="data.level_type" :code="showCode(data)" :imei="data.produce_imei"></m-product-info>
				</template>

				<template #transfer_ratio="{data}">
					{{data.transfer_ratio}}%
				</template>

				<template #cost_price="{data}">
					{{data.cost_price ? '¥' + data.cost_price : '-'}}
				</template>

				<template #sale_price="{data}">
					{{data.sale_price ? '¥' + data.sale_price : '-'}}
				</template>

				<template #profit_amount="{data}">
					<span class="z-profit">{{data.profit_amount ? '¥' + data.profit_amount : '-'}}</span>
				</template>

				<template #receive_state="{data}">
					<!--内置映射渲染，驳回等新值不依赖字典数据-->
					<span :class="receiveStateClass(data.receive_state)">{{receiveStateText(data.receive_state)}}</span>
				</template>

				<template #sale_state="{data}">
					<c-state dict="PROFIT_SALE_STATE" tag :value="data.sale_state"></c-state>
				</template>

				<template #return_state="{data}">
					<c-state v-if="data.return_state" dict="PROFIT_LINE_RETURN_STATE" tag :value="data.return_state"></c-state>
					<span v-else>-</span>
				</template>

				<template #settle_state="{data}">
					<c-state dict="PROFIT_SETTLE_STATE" tag :value="data.settle_state"></c-state>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="100"
				>
					<template #default="{data}">
						<c-table-button v-if="canSettle(data) && auth('b_profit_transfer_settle')" icon="tf-check" color="main" @click="settleOne(data)">结算</c-table-button>
					</template>
				</c-table-column>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import {asyncMapState} from '@/store'

	export default {
		name: 'm_profit_transfer_item',

		computed: {
			...mapState(['saasInfo', 'userInfo']),

			...asyncMapState(['PROFIT_SALE_STATE', 'PROFIT_SETTLE_STATE', 'PROFIT_RECEIVE_STATE'])
		},

		methods: {
			/********背贴码展示口径：调入侧接收后显示新码（方向以行数据 direction 判断）************/
			showCode(data) {
				if (data.direction == 2 && data.receive_state == 1 && data.target_produce_unique_code) {
					return data.target_produce_unique_code;
				}
				return data.produce_unique_code;
			},

			/********接收状态四态文本（内置映射，驳回等新值不依赖字典数据）************/
			receiveStateText(state) {
				if (state == 1) {
					return '已接收';
				}
				if (state == 2) {
					return '驳回中';
				}
				if (state == 3) {
					return '已驳回';
				}
				return '待接收';
			},

			/********接收状态四态颜色************/
			receiveStateClass(state) {
				if (state == 1) {
					return 'z-received';
				}
				if (state == 2) {
					return 'z-rejecting';
				}
				if (state == 3) {
					return 'z-rejected';
				}
				return 'z-pending';
			},

			/********是否可结算************/
			canSettle(data) {
				return data.receive_state == 1 && data.sale_state == 1 && data.settle_state == 0 && data.return_state != 1;
			},

			/********单笔结算************/
			settleOne(data) {
				this.doSettle([data.id], '确认结算背贴码【' + this.showCode(data) + '】？');
			},

			/********批量结算************/
			batchSettle() {
				var selected = this.$refs.view.$refs.list.getData('selected');
				if (!selected || !selected.length) {
					this.$message({message: '请先勾选需要结算的记录', type: 'warning'});
					return;
				}
				var validList = selected.filter(item => this.canSettle(item));
				if (!validList.length) {
					this.$message({message: '请勾选【已接收+已售出+未结算】的记录', type: 'warning'});
					return;
				}
				this.doSettle(validList.map(item => item.id), '确认结算所选的' + validList.length + '条记录？');
			},

			/********执行结算************/
			doSettle(ids, message) {
				this.$confirm({
					message: message,
					buttonName: '确定结算',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/profitTransfer/settle',
							data: {ids: ids},
							loading: true,
							success: (res, msg) => {
								this.$message({message: msg || '结算成功', type: 'success'});
								this.$refs.view.update();
							},
							fail: (code, data, msg) => {
								this.$message({message: msg, type: 'error'});
								return false;
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.z-profit {
		color: #f5222d;
	}

	.z-received {
		color: #52c41a;
	}

	.z-rejecting {
		color: #faad14;
	}

	.z-rejected {
		color: #f5222d;
	}

	.z-pending {
		color: #999;
	}
</style>
